import { useQuery } from '@tanstack/react-query';

import { getCompanySetting } from '../../../store/Settings/api';

export const useGetSettings = () => {
    return useQuery(["company-settings"], getCompanySetting);
}
